<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Ambassades
        <span class="separator" />
      </h1>
    </b-col>
    <ListeStatsAmbassades />
  </div>
</template>

<script>
import ListeStatsAmbassades from "@/components/stats/ListeStatsAmbassades.vue";

export default {
  name: "StatsAmbassades",
  components: {
    ListeStatsAmbassades,
  },
};
</script>

<style lang="scss" scoped>
</style>
